/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OpenPageAction = {
  type: "open_page";
  url: string;
};

/** @internal */
export const OpenPageAction$inboundSchema: z.ZodType<
  OpenPageAction,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("open_page"),
  url: z.string(),
});
/** @internal */
export type OpenPageAction$Outbound = {
  type: "open_page";
  url: string;
};

/** @internal */
export const OpenPageAction$outboundSchema: z.ZodType<
  OpenPageAction$Outbound,
  z.ZodTypeDef,
  OpenPageAction
> = z.object({
  type: z.literal("open_page"),
  url: z.string(),
});

export function openPageActionToJSON(openPageAction: OpenPageAction): string {
  return JSON.stringify(OpenPageAction$outboundSchema.parse(openPageAction));
}
export function openPageActionFromJSON(
  jsonString: string,
): SafeParseResult<OpenPageAction, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenPageAction$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenPageAction' from JSON`,
  );
}
